import { Directive, Input } from '@angular/core';

@Directive({ standalone: false, selector: '[flTrackingSection]' })
export class TrackingSectionDirective {
  @Input() flTrackingSection: string;
}
